import React from 'react';
import { ArrowUpRight } from 'lucide-react';

export default function BlogSideRail() {
  return (
    <aside className="hidden lg:flex fixed left-5 top-1/2 -translate-y-1/2 z-40" data-testid="home-blog-side-rail">
      <a
        href="/blog"
        data-testid="home-blog-side-rail-link"
        className="cursor-hover group flex flex-col items-center gap-3 rounded-full border border-white/10 bg-[#0A0B0E]/70 px-3 py-5 text-[#F5F1E8] backdrop-blur-xl transition-[border-color,background-color,transform] duration-300 hover:-translate-y-1 hover:border-[#D4AF37]/60 hover:bg-[#D4AF37]/10"
        aria-label="Acessar blog da Thesis"
      >
        <span className="h-2 w-2 rounded-full bg-[#D4AF37] shadow-[0_0_18px_rgba(212,175,55,0.75)]" />
        <span className="[writing-mode:vertical-rl] rotate-180 font-mono-label text-[#D4AF37]">BLOG SEO</span>
        <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </a>
    </aside>
  );
}